module.exports = __webpack_public_path__ + "img/mover-abajo.ffe4ceac.png";